// extracted by mini-css-extract-plugin
export default {"checklistButton":"OnboardingChecklist_checklistButton__3ZU8F","checklistIcon":"OnboardingChecklist_checklistIcon__PynyH","badge":"OnboardingChecklist_badge__AcmC7"};